export const resources = {
  junior: {
    macos: [
      { name: 'Product Management Fundamentals', url: 'https://www.productplan.com/learn/', type: 'fundamentals' },
      { name: 'Agile Product Management', url: 'https://www.scrum.org/resources/what-is-a-product-owner', type: 'methodology' },
      { name: 'User Story Writing Guide', url: 'https://www.atlassian.com/agile/project-management/user-stories', type: 'requirements' },
      { name: 'Product Analytics Basics', url: 'https://amplitude.com/blog/product-analytics', type: 'analytics' }
    ],
    windows: [
      { name: 'Microsoft Product Management', url: 'https://docs.microsoft.com/en-us/azure/devops/boards/', type: 'tools' },
      { name: 'Power BI for Product Managers', url: 'https://powerbi.microsoft.com/en-us/learning/', type: 'analytics' },
      { name: 'Azure DevOps for Product Teams', url: 'https://docs.microsoft.com/en-us/azure/devops/boards/work-items/', type: 'project-management' },
      { name: 'Office 365 for Collaboration', url: 'https://support.microsoft.com/en-us/office', type: 'collaboration' }
    ],
    linux: [
      { name: 'Open Source Product Management', url: 'https://opensource.guide/leadership-and-governance/', type: 'methodology' },
      { name: 'Command Line Tools for PMs', url: 'https://github.com/donnemartin/system-design-primer', type: 'tools' },
      { name: 'Data Analysis with Python', url: 'https://pandas.pydata.org/docs/', type: 'analytics' },
      { name: 'Git for Product Managers', url: 'https://git-scm.com/book', type: 'version-control' }
    ]
  },
  mid: {
    macos: [
      { name: 'Product Strategy Framework', url: 'https://www.reforge.com/blog/product-strategy', type: 'strategy' },
      { name: 'Growth Product Management', url: 'https://www.reforge.com/blog/growth-product-management', type: 'growth' },
      { name: 'Product-Market Fit Guide', url: 'https://pmarchive.com/guide_to_startups_part4.html', type: 'market-fit' },
      { name: 'OKRs for Product Teams', url: 'https://www.whatmatters.com/resources/okrs-for-product-teams', type: 'goal-setting' }
    ],
    windows: [
      { name: 'Enterprise Product Management', url: 'https://docs.microsoft.com/en-us/azure/architecture/', type: 'enterprise' },
      { name: 'B2B Product Strategy', url: 'https://www.microsoft.com/en-us/microsoft-365/business-insights-ideas/', type: 'b2b' },
      { name: 'Data-Driven Product Decisions', url: 'https://powerbi.microsoft.com/en-us/what-is-power-bi/', type: 'data-driven' },
      { name: 'Customer Success Integration', url: 'https://dynamics.microsoft.com/en-us/customer-service/', type: 'customer-success' }
    ],
    linux: [
      { name: 'Technical Product Management', url: 'https://github.com/ProductHired/open-product-management', type: 'technical' },
      { name: 'API Product Management', url: 'https://swagger.io/resources/articles/best-practices-in-api-design/', type: 'api-products' },
      { name: 'DevOps for Product Managers', url: 'https://www.atlassian.com/devops', type: 'devops' },
      { name: 'Platform Product Management', url: 'https://martinfowler.com/articles/talk-about-platforms.html', type: 'platform' }
    ]
  },
  senior: {
    macos: [
      { name: 'Product Leadership', url: 'https://svpg.com/articles/', type: 'leadership' },
      { name: 'Strategic Product Planning', url: 'https://www.mckinsey.com/business-functions/strategy-and-corporate-finance', type: 'strategic-planning' },
      { name: 'Product Portfolio Management', url: 'https://www.bcg.com/capabilities/digital-technology-data/digital-product-management', type: 'portfolio' },
      { name: 'Innovation Management', url: 'https://hbr.org/topic/innovation', type: 'innovation' }
    ],
    windows: [
      { name: 'Enterprise Product Strategy', url: 'https://www.microsoft.com/en-us/enterprise', type: 'enterprise-strategy' },
      { name: 'Digital Transformation', url: 'https://www.microsoft.com/en-us/digital/digital-transformation', type: 'transformation' },
      { name: 'AI Product Management', url: 'https://docs.microsoft.com/en-us/azure/cognitive-services/', type: 'ai-products' },
      { name: 'Cloud Product Strategy', url: 'https://azure.microsoft.com/en-us/overview/what-is-cloud-computing/', type: 'cloud-strategy' }
    ],
    linux: [
      { name: 'Open Source Product Strategy', url: 'https://opensource.com/business/16/6/bad-practice-foss-projects-management', type: 'open-source' },
      { name: 'Technical Architecture for PMs', url: 'https://github.com/donnemartin/system-design-primer', type: 'architecture' },
      { name: 'Scalability Planning', url: 'https://12factor.net/', type: 'scalability' },
      { name: 'Developer Experience', url: 'https://github.com/readme/guides/developer-onboarding', type: 'developer-experience' }
    ]
  }
};
